/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Vs_Yaml_Xml_C1Inputs */

const en_guide_json_vs_yaml_xml_c1 = /** @type {(inputs: Guide_Json_Vs_Yaml_Xml_C1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A side-by-side comparison of the three formats`)
};

const ko_guide_json_vs_yaml_xml_c1 = /** @type {(inputs: Guide_Json_Vs_Yaml_Xml_C1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`세 형식의 나란한 비교`)
};

const ja_guide_json_vs_yaml_xml_c1 = /** @type {(inputs: Guide_Json_Vs_Yaml_Xml_C1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3つの形式の並列比較`)
};

/**
* | output |
* | --- |
* | "A side-by-side comparison of the three formats" |
*
* @param {Guide_Json_Vs_Yaml_Xml_C1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_vs_yaml_xml_c1 = /** @type {((inputs?: Guide_Json_Vs_Yaml_Xml_C1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Vs_Yaml_Xml_C1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_vs_yaml_xml_c1(inputs)
	if (locale === "ko") return ko_guide_json_vs_yaml_xml_c1(inputs)
	return ja_guide_json_vs_yaml_xml_c1(inputs)
});